import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage, ref, getBytes } from "firebase/storage";
import Page404 from "./Page404"; // Import 404 page
import { db, storage } from "../firebase-config";
import { Box, Chip,  } from "@mui/material";

const ToolView = () => {
  const { toolid } = useParams(); // Get tool ID from the route
  const [iframeSrc, setIframeSrc] = useState(null);
  const [isOwner, setIsOwner] = useState(false); // Check ownership
  const [error, setError] = useState(null);
  const [toolExists, setToolExists] = useState(true); // Track if tool exists
  const [toolData, setToolData] = useState({}); // Track if tool exists

  useEffect(() => {
    const fetchTool = async () => {
      try {
        const toolDoc = await getDoc(doc(db, "tools", toolid));
        if (toolDoc.exists()) {
          setToolData({...toolDoc.data(),id:toolDoc.id})
          const toolData2 = toolDoc.data();

          // Fetch the file content from Firebase Storage
          const fileRef = ref(storage, `tools/${toolid}`);
          const fileBytes = await getBytes(fileRef);
          const fileContent = new TextDecoder("utf-8").decode(fileBytes);

          // Create a Blob URL for embedding the HTML in the iframe
          const blob = new Blob([fileContent], { type: "text/html" });
          const blobUrl = URL.createObjectURL(blob);
          setIframeSrc(blobUrl);

          // Check if the current user is the owner
          const auth = getAuth();
          const currentUser = auth.currentUser;
          if (currentUser && toolData2.ownerId === currentUser.uid) {
            setIsOwner(true);
          }
        } else {
          setToolExists(false); // Mark tool as not found
        }
      } catch (err) {
        setError("Failed to load the tool");
        console.error("Error fetching tool:", err);
      }
    };

    fetchTool();
  }, [toolid]);

  const handleDownload = async () => {
    try {
      const fileRef = ref(storage, `tools/${toolid}`);
      const fileBytes = await getBytes(fileRef);
      const fileContent = new TextDecoder("utf-8").decode(fileBytes);

      // Create a downloadable link
      const blob = new Blob([fileContent], { type: "text/html" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${toolData.title ? toolData.title : toolid}.html`;
      link.click();

      // Revoke the object URL to save memory
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Failed to download the tool file.");
    }
  };

  if (!toolExists) {
    return <Page404 />; // Show 404 page if the tool does not exist
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!iframeSrc) {
    return <div>Loading...</div>; // Show a loading state while fetching
  }

  return (
    <div>
      <h1>{toolData.title}</h1>
      <Box mt={1} display="flex" gap={1} flexWrap="wrap">
          {toolData && toolData.tags.map((tag, index) => (
            <Chip
            style={{cursor:"pointer"}}
              key={index}
              label={tag}
              color="primary"
              component={Link}
              to={`http://localhost:3000/tool/?tab=${tag}`}
            />
          ))}
        </Box>
      <p>{toolData.description}</p>

      {isOwner && (
        <div style={{ marginTop: "20px" }}>
          <Link to={`/tool/edit/${toolid}`} style={{ textDecoration: "none", color: "blue" }}>
            Edit this Tool
          </Link>
        </div>
      )}

      <div style={{ marginTop: "20px" }}>
        <button onClick={handleDownload} style={{ padding: "10px 15px", cursor: "pointer" }}>
          Download Offline Tool
        </button>
      </div>

      <iframe
        src={iframeSrc}
        style={{ width: "100%", height: "600px", border: "none" }}
        title="Tool Viewer"
      ></iframe>
    </div>
  );
};

export default ToolView;
